
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FormControl } from '@angular/forms';

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { AlertService, Constants } from 'src/app/shared/index';
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'solar-monthly-report',
  templateUrl: './solar-monthly-report.component.html',
  styleUrls: ['./solar-monthly-report.component.scss'],
  providers: [
    // The locale would typically be provided on the root module of your application. We do it at
    // the component level here, due to limitations of our example generation script.
    // {provide: MAT_DATE_LOCALE, useValue: 'hi-IN'},
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class SolarMonthlyReportComponent implements OnInit, OnDestroy {
  siteId = '';
  date = new FormControl(moment());
  reportType: string;
  navigationSubscription: any;
  max = new Date();
  constructor(public commonService: CommonService, private activeRoute: ActivatedRoute,
    private alertService: AlertService, private dataService: DataService, private router: Router) {
     
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // console.log('Router event:', e);
      if (e instanceof (NavigationEnd)) {
        this.siteId = localStorage.getItem('siteId');
        this.reportType = this.activeRoute.snapshot.paramMap.get('type');
        // console.log('reportType:', this.reportType);
      }

    });
  }
  ngOnInit() {

  }
  ngOnDestroy() {
    if (this.navigationSubscription) {
       this.navigationSubscription.unsubscribe();
    }
  }
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
  }

  ok() {
    let url = '';
    if (this.date.value) {

      const selectedMonth = this.date.value.format('YYYY-MM');

      switch (this.reportType) {
        case 'solar':
          url = this.commonService.getgenerateMonthlySolarReportUrl(this.siteId, selectedMonth);
          break;
        case 'energy':
          url = this.commonService.getMonthlyEnergyReportUrl(this.siteId, selectedMonth);
          // url = this.commonService.getMonthlyEnergyReportUrl('JAPBOSCH30201064', '2018-11');
          break;
        default:
          url = this.commonService.getgenerateMonthlySolarReportUrl(this.siteId, selectedMonth);
          break;
      }
      // console.log('URL: ' + url);
      this.dataService.getPDF(url, true).subscribe((response) => {
        if (response.byteLength > 0) {
          const file = new Blob([response], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
        } else {
          this.alertService.message = 'No data response !';
          this.alertService.showError();
        }

      });

    }
  }
}
